<template>
	<div>
		<div class="row">
			<div class="mb-3">          
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6">
									<el-form-item label="Branch:">
										<el-select v-model="filter.branch" clearable filterable placeholder="Select Store" size="medium" style="width:100%;">
											<el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName=='supplychain' || tabName=='tracking_process_pb'">
									<el-form-item label="To Branch:">
										<el-select v-model="filter.branchto" clearable filterable placeholder="Select Store" size="medium" style="width:100%;">
											<el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName=='commercial'">
									<el-form-item label="Commercial Metric:">
										<el-select v-model="filtertemp.metric" clearable filterable placeholder="Select Commercial Metrics" size="medium" style="width:100%;">
											<el-option v-for="item3 in options.commercialmetrics" :key="item3.value" :label="item3.name" :value="item3.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName=='operational'">
									<el-form-item label="Operational Metric:">
										<el-select v-model="filtertemp.metric" clearable filterable placeholder="Select Operational Metrics" size="medium" style="width:100%;">
											<el-option v-for="item3 in options.operationalmetrics" :key="item3.value" :label="item3.name" :value="item3.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName=='supplychain'">
									<el-form-item label="Supply Chain Metric:">
										<el-select v-model="filtertemp.metric" clearable filterable placeholder="Select Supply Chain Metrics" size="medium" style="width:100%;">
											<el-option v-for="item3 in options.supplychainmetrics" :key="item3.value" :label="item3.name" :value="item3.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div><!--
							<div class="row">
								<div class="col-md-12">
									<el-form-item label="Commercial Metrics:">
										<el-radio-group v-model="filter.metric" size="small">
											<el-radio-button :label="item2.value" v-for="(item2, index2) in options.status" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>-->
							<div class="row" v-if="tabName=='supplychain'">
								<div class="col-md-6" >
									<el-form-item label="Area">
										<el-radio-group v-model="area" size="small">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" >
									<el-form-item label="Category">
										<el-radio-group v-model="filter.category" size="small">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.kategori" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>

							<div class="row">
								<div class="col-md-5">
									<el-form-item label="Date Range:">
										<div class="block">
											<el-date-picker
											v-model="filter.dateRange"
											type="daterange"
											align="right"
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>
							</div>									

							<div class="row">
								<div class="col-md-5">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="row">
				<div class="col-md-3 mb-3">
					<el-checkbox v-model="showchart">Show Chart</el-checkbox>
				</div>
				<div class="col-md-4 mb-3" v-if="showchart">
					<el-radio-group v-model="charttype">
						<el-radio label="barchart" size="small" v-if="tabName != 'tracking_process_pb' ">Bar Chart</el-radio>
						<el-radio label="linechart" size="small" v-if="tabName != 'tracking_process_pb' ">Line Chart</el-radio>
						<el-radio label="piechart" size="small" v-if="tabName == 'tracking_process_pb' ">Pie Chart</el-radio>
					</el-radio-group>
				</div>
				
			</div>
			<div class="mb-0" >
				<BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
				<LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
				<PieChart v-loading.body="loading.piechart" :data="piechartdata" :url="''" v-if="showchart && charttype=='piechart'" style="width:250px;" />
			</div>

			<div class="row mt-4" v-if="showchart && tabName=='supplychain'">
				<div class="col-md-4 mb-3">
					<div class="text-center">{{this.filter.metricName}}</div>
					<BarChart v-loading.body="loading.chart" :data="chartdatasalesyear" :width="500" :height="300"/>
					<div class="mt-2" v-loading.body="loading.chart">
						<table class="table table-bordered text-center" style="width: 80%;margin: 0 auto;">
							<tr style="background:#F5F7FA;">
								<th>Last Year</th>
								<th>This Year</th>
							</tr>
							<tr>
								<td style="padding:5px 0px;"><strong>{{ this.sss.year.lastyear }}</strong></td>
								<td style="padding:5px 0px;"><strong>{{ this.sss.year.thisyear }}</strong></td>
							</tr>
						</table>
					</div>	
					<el-alert v-loading.body="loading.chart" class="mt-2" :title="this.sss.year.comparisonresult" :type="this.sss.year.alerttype" effect="dark" center :closable="false" style="width:80%;margin: 0 auto;"></el-alert>

				</div>
				<div class="col-md-4 mb-3">
					<div class="text-center">{{this.filter.metricName}}</div>
					<BarChart v-loading.body="loading.chart" :data="chartdatasalesmonth" :width="500" :height="300"/>
					<div class="mt-2" v-loading.body="loading.chart">
						<table class="table table-bordered text-center" style="width: 80%;margin: 0 auto;">
							<tr style="background:#F5F7FA;">
								<th>Last Month</th>
								<th>This Month</th>
							</tr>
							<tr>
								<td style="padding:5px 0px;"><strong>{{ this.sss.month.lastmonth }}</strong></td>
								<td style="padding:5px 0px;"><strong>{{ this.sss.month.thismonth }}</strong></td>
							</tr>
						</table>
					</div>	
					<el-alert v-loading.body="loading.chart" class="mt-2" :title="this.sss.month.comparisonresult" :type="this.sss.month.alerttype" effect="dark" center :closable="false" style="width:80%;margin: 0 auto;"></el-alert>

				</div>

				<div class="col-md-4 mb-3">
					<div class="text-center">{{this.filter.metricName}} </div>
					<BarChart v-loading.body="loading.chart" :data="chartdatasalesweek" :width="500" :height="300"/>
					<div class="mt-2" v-loading.body="loading.chart">
						<table class="table table-bordered text-center" style="width: 80%;margin: 0 auto;">
							<tr style="background:#F5F7FA;">
								<th>Last Week</th>
								<th>This Week</th>
							</tr>
							<tr>
								<td style="padding:5px 0px;"><strong>{{ this.sss.week.lastweek }}</strong></td>
								<td style="padding:5px 0px;"><strong>{{ this.sss.week.thisweek }}</strong></td>
							</tr>
						</table>
					</div>	
					<el-alert v-loading.body="loading.chart" class="mt-2" :title="this.sss.week.comparisonresult" :type="this.sss.week.alerttype" effect="dark" center :closable="false" style="width:80%;margin: 0 auto;"></el-alert>

				</div>
			</div>

			<div class="mt-0">
				<ReportResultTable :reportname="'BaselineComparisonReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
			</div>
		</div>
	</div>
</template>

<script>
 
import Bright from '@/components/page/Bright.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, AxiosWithJar, Config} from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

export default
{
	extends: Bright,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		LineChart,
		BarChart,
		PieChart,
		//Loader,
	},

	data(){
		return {
			filter: {
				branch: this.$route.query.branch ? this.$route.query.branch : '',
				branchto: this.$route.query.branch ? this.$route.query.branch : '',
				metric: '',
				area: '',
				category: '',
				metricName: 'Self-service sales (IDR)',
				startDate: '',
				endDate: '',
				dateRange: [], 
			},
			filtertemp: {
				metric: '',
				commercialmetric: '',
				operationalmetric: '',
				supplychainmetric: '',
			},
			loading: {
				table: false,
				chart: false,
				piechart: false,
				isSuccess: false,
			},
			charttype: 'linechart', //barchart //linechart
			reportdata: [],
			chartdata: [],
			chartdatasalesyear: [],
			chartdatasalesmonth: [],
			chartdatasalesweek: [],
			piechartdata: [],
			showchart: false,
			stationList: [],
			//category: '',
			options: { 
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				kategori:[
					{ value: "", name: "ALL" }, 
					{ value: "manual", name: "Manual" }, 
					{ value: "auto", name: "Auto" }, 
					{ value: "alokasi", name: "Alokasi" }, 
				],
				commercialmetrics: [
					{ value: "COMBAT", name: "COMBAT in-store sales (IDR)" }, 
					{ value: "2", name: "COMBAT in-store sales (# of units)" }, 
					{ value: "3", name: "COMBAT in-store sales (# of transaction)" }, 
					{ value: "TROLI", name: "Bright trolley sales (IDR)" }, 
					{ value: "5", name: "Bright trolley sales (# of units)" }, 
					{ value: "6", name: "Bright trolley sales (# of transaction)" }, 
					{ value: "CASH", name: "One Time Customer" },
					{ value: "O2O", name: "O2O" }, 
				],
				operationalmetrics: [
					{ value: "OPR_SM_1", name: "# SKUs in stock but not in planogram design" }, 
					{ value: "OPR_SM_2", name: "% of implemented planogram" }, 
					{ value: "OPR_SM_3", name: "# SKUs with uncorrect label (promo & price)" }, 
					{ value: "OPR_SM_4", name: "# Broken equipment" }, 
					{ value: "OPR_SM_5", name: "% top 100 SKU available in store" }, 
					{ value: "OPR_SM_6", name: "% of hero promotion visual displayed correctly*" }, 
				],
				supplychainmetrics: [
					//{ value: "SUC_SM_1", name: "# SKUs stock-out Unit" }, 
					//{ value: "SUC_SM_2", name: "Average Stock Days" }, 
					{ value: "DC_SERVICE_LEVEL", name: "DC Service Level (%)" }, 
				],
			},
			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			sss: {
				year: {
					lastyear: '0',
					thisyear: '0',
					alerttype: 'error', //success
					comparisonresult: '0',
				},
				month: {
					lastmonth: '0',
					thismonth: '0',
					alerttype: 'error', //success
					comparisonresult: '0',
				},
				week: {
					lastweek: '0',
					thisweek: '0',
					alerttype: 'error', //success
					comparisonresult: '0',
				},
			},
			
			urlRequestParams: '',
			//branch: this.$route.query.branch ? this.$route.query.branch : '',
			//tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			area: this.$route.query.area ? this.$route.query.area : '',
			status: this.$route.query.status ? this.$route.query.status : '',

		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },

	}, 
    mounted()
    {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		
        this.$emit('childrenRoute');

		if (this.tabName == 'operational') {
			this.filter.metric = 'OPR_SM_6'
			this.filtertemp.metric = 'OPR_SM_6'
		} else if(this.tabName == 'supplychain') {
			this.filter.metric = 'DC_SERVICE_LEVEL' //SUC_SM_1
			this.filtertemp.metric = 'DC_SERVICE_LEVEL' //SUC_SM_1
		} else if(this.tabName == 'tracking_process_pb') {
			this.charttype= 'piechart'
			this.getPiechartTrackingProcessPB()
		}
		this.getMetricTitleName()

		this.loadStoreList2()
		//this.resumePilihan()
//		this.getBaselineComparison()

		if(this.tabName != 'tracking_process_pb') {
		this.getBaselineChartSelfServiceSales()
		}
		

		//this.getStationList()
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},
		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			//if (this.tabIndex == 0) 
				this.urlRequestParams+='/bright/storelist?'

			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&status='+this.status

			this.loading.table = true
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
					this.loading.isSuccess = true;
				})
				.catch(error => {
					//console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
		async getBaselineComparison() {
			this.urlRequestParams=Config().apiURL
			if (this.tabName == 'commercial') this.urlRequestParams+='/bright/baseline?'
			else if (this.tabName == 'operational') this.urlRequestParams+='/bright/baseline-operational?'
			else if (this.tabName == 'supplychain') {
				if(this.filter.metric == 'DC_SERVICE_LEVEL') {
					this.urlRequestParams+='/bright/baseline-supplychain-dsl?'
				} else {
					this.urlRequestParams+='/bright/baseline-supplychain?'
				}
			} 
			else if (this.tabName == 'tracking_process_pb') {
				this.urlRequestParams+='/bright/baseline/tracking-pb?'
			}

			this.urlRequestParams+='&branch='+this.filter.branch
			this.urlRequestParams+='&branchto='+this.filter.branchto
			if (this.filter.dateRange !== null && this.filter.dateRange.length > 0) {
			this.urlRequestParams+='&startDate='+ this.filter.dateRange[0] 
			this.urlRequestParams+='&endDate='+  this.filter.dateRange[1] 
			}
			this.urlRequestParams+='&metrics='+this.filter.metric
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&category='+this.filter.category

			this.loading.table = true
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					let legend = "groupmembername";
					let label = "posdate";
					let valuecol = "totaltransaction";
					let prefix = "";

					if (this.tabName == 'operational') {
						legend = "SubMetricsName";
						label = "date";
						valuecol = "total";
						prefix = "";
					} else if (this.tabName == 'supplychain') {
						if(this.filter.metric == 'DC_SERVICE_LEVEL') {
							legend = "SubMetricsName";
							label = "PBDate";
							valuecol = "CompleteOrderinPercentage";
							prefix = "";
						} else {
							legend = "SubMetricsName";
							label = "date";
							valuecol = "CountItemOOS";
							prefix = "";
						}				
					} else if(this.tabName == 'tracking_process_pb') {
						legend = "SubMetricsName";
						label = "date";
						valuecol = "total";
						prefix = "";
					}

					this.chartdata = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false);
					this.reportdata = response.data;
					this.loading.table = false
					this.loading.isSuccess = true;
					//console.log('data: ' + JSON.stringify(this.chartdata));
				})
				.catch(error => {
					//console.log('err: ' + error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
		async getBaselineChartSelfServiceSales(){
			this.urlRequestParams=Config().apiURL
			if (this.tabName == 'commercial') this.urlRequestParams+='/bright/baseline/self-service-sales-chart?'
			else if (this.tabName == 'operational') this.urlRequestParams+='/bright/baseline/operational-chart?'
			else if (this.tabName == 'supplychain') {
				if(this.filter.metric == 'DC_SERVICE_LEVEL')
					this.urlRequestParams+='/bright/baseline/supplychain-chart-dsl?'
				else
					this.urlRequestParams+='/bright/baseline/supplychain-chart?'
			} 

			this.urlRequestParams+='&branch='+this.filter.branch
			this.urlRequestParams+='&startDate='+this.filter.dateRange[0]
			this.urlRequestParams+='&endDate='+this.filter.dateRange[1]
			this.urlRequestParams+='&metrics='+this.filter.metric
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&category='+this.filter.category

			this.loading.chart = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					let legend = "label";
					let label = "legend";
					let valuecol = "total"; //totaltransaction
					let prefix = "";
					this.chartdatasalesyear = this.processBarChart(response.data.data.year, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false);
					this.chartdatasalesmonth = this.processBarChart(response.data.data.month, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false);
					this.chartdatasalesweek = this.processBarChart(response.data.data.week, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false);

					let sumThisYear = this.sumSelfSserviceSales(response.data.data.year, 'This Year');
					let sumLastYear = this.sumSelfSserviceSales(response.data.data.year, 'Last Year');
					let comparisonValueYear =  ((sumThisYear-sumLastYear)/sumLastYear) * 100

					let sumThisMonth = this.sumSelfSserviceSales(response.data.data.month, 'This Month');
					let sumLastMonth = this.sumSelfSserviceSales(response.data.data.month, 'Last Month');
					let comparisonValueMonth =  ((sumThisMonth-sumLastMonth)/sumLastMonth) * 100
					
					let sumThisWeek = this.sumSelfSserviceSales(response.data.data.week, 'This Week');
					let sumLastWeek = this.sumSelfSserviceSales(response.data.data.week, 'Last Week');
					let comparisonValueWeek =  ((sumThisWeek-sumLastWeek)/sumLastWeek) * 100

					if(this.filter.metric == 'DC_SERVICE_LEVEL') {
						comparisonValueYear = sumThisYear-sumLastYear;
						comparisonValueMonth = sumThisMonth-sumLastMonth;
						comparisonValueWeek = sumThisWeek-sumLastWeek;
					}

					this.sss.year = {
						lastyear: sumLastYear.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
						thisyear: sumThisYear.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
						alerttype: (comparisonValueYear < 0) ? 'error' : 'success', //
						comparisonresult: comparisonValueYear.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') +' %',
					}

					this.sss.month = {
						lastmonth: sumLastMonth.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
						thismonth: sumThisMonth.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
						alerttype: (comparisonValueMonth < 0) ? 'error' : 'success',
						comparisonresult: comparisonValueMonth.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') +' %',
					}

					this.sss.week = {
						lastweek: sumLastWeek.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
						thisweek: sumThisWeek.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
						alerttype: (comparisonValueWeek < 0) ? 'error' : 'success',
						comparisonresult: comparisonValueWeek.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') +' %',
					}

				})
				.catch(error => {
					//console.log('err: ' + error)
				})
				.finally(() => {
					this.loading.chart = false;
				})
        },

		getPiechartTrackingProcessPB() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/bright/baseline/tracking-pb-piechart?'
			
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&branch='+this.filter.branch
			this.urlRequestParams+='&branchto='+this.filter.branchto
			if (this.filter.dateRange !== null && this.filter.dateRange.length > 0) {
			this.urlRequestParams+='&startDate='+ this.filter.dateRange[0]
			this.urlRequestParams+='&endDate='+ this.filter.dateRange[1]
			}

			this.loading.piechart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				//this.chartresponsedata = response.data.data;
				//this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);
			
				let responsedata = response.data.data
				
				let item = responsedata
				var warna = []
				let value = [];
				let idx = 0;
				for (var row in item) {
					//add color
					warna[item[row].pbstatus] = Rainbow[idx];//'#FFB22E'

					//add value
					let main = {
						transtype: item[row].pbstatus, 
						amount: item[row].cnt,
					};

					value.push(main);
					idx++;
				}

				this.piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.piechart = false;
			})

		},

		sumSelfSserviceSales(data, label) {
			let sum = 0; 
			for (let i = 0; i < data.length; i++) {
				if(data[i].label == label) 
					sum += data[i].total //totaltransaction					
			}
			return sum
		},
		applyFilter() {
			this.getMetricTitleName()
			this.getBaselineComparison()
			
			if(this.tabName == 'tracking_process_pb') {
				this.getPiechartTrackingProcessPB()
			} else {
				this.getBaselineChartSelfServiceSales()
			}
        },
		getMetricTitleName() {
			//this.resumePilihan()
			this.filter.metric = this.filtertemp.metric
			if(this.filter.metric != '') {
				let selectedMetric = '' ; //this.options.metrics.find(x => x.value == this.filter.metric)
				//console.log('selectedMetric: ' + selectedMetric.name) 
				//, , 
				if (this.tabName == 'commercial') {
					selectedMetric = this.options.commercialmetrics.find(x => x.value == this.filter.metric)
				} else if (this.tabName == 'operational') {
					selectedMetric = this.options.operationalmetrics.find(x => x.value == this.filter.metric)
				} else if (this.tabName == 'supplychain') {
					selectedMetric = this.options.supplychainmetrics.find(x => x.value == this.filter.metric)
				}

				this.filter.metricName = selectedMetric.name
			} else {
				this.filter.metricName = 'All Metrics'
			}
		},
		getStationList() {
			let stations = this.store.list;
			this.stationList = [];
			if(this.filter.metric == 'DC_SERVICE_LEVEL') {
				//this.stationList = [];
				for (let i = 0; i < stations.length; i++) {
					if(stations[i].BranchId == 'DHLCKG1' || stations[i].BranchId == 'DHLSBY1') {
						this.stationList.push(stations[i]);
					}
				}
			} else {
				for (let i = 0; i < stations.length; i++) {
					this.stationList.push(stations[i]);
				}
			}
		}
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>